import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function ReadingStrand({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-3.5 -7.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <path d="M33.6742034 1.5796138C22.1362553.04159493 17.1931244 7.55487323 17.1931244 7.55487323 10.5730478-.0580395.80326002 1.77256781.80326002 1.77256781l2.1912559 20.85938089c9.09409788-1.4889033 14.24421578 2.6732901 14.24421578 2.6732901 6.2301709-4.4266835 14.4631309-2.6732901 14.4631309-2.6732901l1.9723408-21.0523349zM17.2979511 7.55459257V25.3049581" />
      </g>
    </svg>
  )
}

ReadingStrand.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
